import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=0ac82792&scoped=true&lang=pug&"
import script from "./Sidebar.js?vue&type=script&lang=js&"
export * from "./Sidebar.js?vue&type=script&lang=js&"
import style0 from "./Sidebar.sass?vue&type=style&index=0&id=0ac82792&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac82792",
  null
  
)

export default component.exports